import { setRunnerUrl } from '../Config';

export const SELECTED_CLUSTER_STORAGE_KEY = 'mermadic_selected_cluster';
export const USER_ID_STORAGE_KEY = 'mermadic_user_id';

const RUNNER_DOMAIN = 'mermadicrunner.com';

export function persistSelectedCluster(fullClusterName) {
  if (fullClusterName) {
    localStorage.setItem(SELECTED_CLUSTER_STORAGE_KEY, fullClusterName);
  }
}

export function getStoredSelectedCluster() {
  return localStorage.getItem(SELECTED_CLUSTER_STORAGE_KEY);
}

/**
 * Keep the account's user_id from a get-user-info cluster list. Every entry carries the
 * same id, so the first one that has it wins.
 */
export function persistUserIdFromClusters(list) {
  const entries = Array.isArray(list) ? list : [list];
  const uid = entries.find((c) => c && c.user_id)?.user_id;
  if (uid) localStorage.setItem(USER_ID_STORAGE_KEY, String(uid));
}

export function getStoredUserId() {
  return localStorage.getItem(USER_ID_STORAGE_KEY);
}

/**
 * Cluster part of an app's mermadicrunner.com host, matching what the job-runner mints.
 * A dedicated cluster id already begins with the user id; the shared cluster is named
 * 'default' internally and serves every account, so its hosts carry the id instead.
 */
export function clusterHostPrefix() {
  const cluster = getStoredSelectedCluster() || 'default';
  if (cluster !== 'default') return cluster;
  const uid = getStoredUserId();
  return uid ? `shared-${uid}` : 'shared';
}

export function mermadicHostForApp(appName) {
  return `${clusterHostPrefix()}-${appName}.${RUNNER_DOMAIN}`;
}

export function clearSelectedCluster() {
  try {
    localStorage.removeItem(SELECTED_CLUSTER_STORAGE_KEY);
    localStorage.removeItem(USER_ID_STORAGE_KEY);
  } catch { /* ignore */ }
}

/**
 * Switch which job-runner base URL the SPA uses (cluster is no longer stored in Cognito).
 * @param {string} fullClusterName — full cluster id (e.g. default or userId-suffix)
 * @param {string} runnerUrl — job-runner API base URL for this cluster
 */
export function switchLocalRunnerCluster(fullClusterName, runnerUrl) {
  if (runnerUrl) setRunnerUrl(runnerUrl);
  persistSelectedCluster(fullClusterName);
}

const TIER_DISPLAY = { dev: 'Gold', prod: 'Premium' };

/**
 * Returns the user-facing display label for a tier value from the API.
 * API values (dev/prod/shared) are mapped to marketing names for display only.
 */
export function tierLabel(tier) {
  if (!tier) return tier;
  return TIER_DISPLAY[tier] ?? (tier.charAt(0).toUpperCase() + tier.slice(1));
}
